<div class="login-form-container">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 logo-container">
        <div class="">
          <div class="logo-wrapper">
            <div class="logo">
              <div><img *ngIf="configService.themeConfig && configService.themeConfig.LogoUrl" [src]="configService.themeConfig.LogoUrl"
                  alt="Site Logo"></div>
            </div>
            <div class="logo-content">
              <h1 *ngIf="configService.themeConfig.Heading">{{'userLogin.logoContent' | translate}}
              </h1>
              <h2 *ngIf="configService.themeConfig.SubHeading !== '' ">
                {{configService.themeConfig.SubHeading}}</h2>
              <div class="small-description">
                <strong *ngIf="configService.themeConfig.TagLine !== '' ">{{configService.themeConfig.TagLine}}</strong><br>
                <span *ngIf="configService.themeConfig.Description">{{'userLogin.smallDescription' | translate}}</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="col-md-4 login-form">
        <div id="login" class="form-container">
          <div id="login-row" class="justify-content-center align-items-center">
            <div id="login-box">
              <p class="login-title">{{'examineeLogin.forgotPwd.title' | translate}}</p>

              <div id="login-column" class="login-column-c">

                <form [formGroup]="loginForm" novalidate>
                  <label for="emailId" class="text-info">{{'examineeLogin.forgotPwd.email' | translate}}<span class="error">*</span></label><br>
                  <input type="text" class="form-control" formControlName="emailId" required
                    [ngClass]="{ 'is-invalid': submitted && f.emailId.errors }">


                  <div class="col-md-12 alert alert-danger" *ngIf="submitted && f.emailId.invalid">
                    <div *ngIf="f.emailId.errors?.required">
                      {{'examineeLogin.forgotPwd.errorMail1' | translate}}</div>
                    <div *ngIf="f.emailId.errors?.pattern">
                      {{'examineeLogin.forgotPwd.errorMail2' | translate}}</div>
                  </div>

                  <div class="form-group">
                    <div>
                      <button type="submit" class="btn-login btn-bg-color" mat-flat-button (click)="reset()">
                        <span>{{'examineeLogin.forgotPwd.btn' | translate}}</span>
                      </button>
                    </div>
                    <div class="display-msg">
                      <P>{{msg}}</P>
                    </div>


                  </div>
                </form>
              </div>

              <span *ngIf="!lockoutMsg" class="error-message invalid-feedback">{{ loginErrorMessage }}</span>
              <div *ngIf="lockoutMsg" class="alert alert-danger">
                <div>{{ loginErrorMessage }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<div class="footer-copyrights" id="cp">
  <!-- © {{fullyear}} SimpliAssess, All Rights Reserved. -->
  © {{fullyear}} {{'footer.text' | translate}}
</div>
